import { LinearProgressBarCoreUniDriver } from './LinearProgressBarCore/LinearProgressBarCore.uni.driver';

export interface LinearProgressBarUniDriver
  extends LinearProgressBarCoreUniDriver {
  isErrorIconShown: () => Promise<boolean>;
  isSuccessIconShown: () => Promise<boolean>;
  getTooltipErrorMessage: () => Promise<string>;
  getPadding: () => Promise<string>;
}
